import { AddressResponseDto } from "../dto/response/address-response-dto.interface";
import { Address } from "../model/address-model";

export function addressMapper(dto: AddressResponseDto): Address {
  return {
    id: dto.id,
    nickname: dto.nickname,
    street: dto.street,
    number: dto.number,
    complement: dto.complement,
    neighborhood: dto.neighborhood,
    city: dto.city,
    state: dto.state,
    uf: dto.stateCode,
    country: dto.country,
    zipcode: dto.zipcode};
}
